export const googleMapAPIKEY = "AIzaSyCrJJxxzVwMQdIpAKxVz6_9xSJeVtJJGzQ" //LI Google API key

export const mapOptions = {
  types: ["establishment", "geocode"],
  componentRestrictions: { country: "au" }
}